import type { NavigationState } from "@/components/widget"
import type { Comment } from "@/types/const.types"
import type { PositionData } from "@/utils/path-builder"
import { create } from "zustand"

type StoreState = {
	// UI State
	commentsOpen: boolean
	commandOpen: boolean
	isAnimated: boolean
	isClickAnimating: boolean
	setCommentsOpen: (value: boolean) => void
	toggleCommentsOpen: () => void
	setCommandOpen: (value: boolean) => void
	toggleCommandOpen: () => void
	setIsAnimated: (value: boolean) => void
	setIsClickAnimating: (value: boolean) => void
	setAnimateClick: () => void

	// Search
	searchQuery: string
	setSearchQuery: (query: string) => void

	// Comments
	isCommentMode: boolean
	commentInput: {
		targetElement: PositionData
		relativeOffset: { xPercent: number; yPercent: number }
		content: string
		isVisible: boolean
	} | null
	selectedComment: Comment | null
	setIsCommentMode: (value: boolean) => void
	setCommentInput: (input: StoreState["commentInput"]) => void
	setSelectedComment: (comment: Comment | null) => void

	// Navigation
	navigation: NavigationState
	setNavigation: (nav: NavigationState) => void
}

export const useAppStore = create<StoreState>((set) => ({
	// UI State
	commentsOpen: false,
	commandOpen: false,
	isAnimated: false,
	isClickAnimating: false,
	setCommentsOpen: (value) => set({ commentsOpen: value }),
	toggleCommentsOpen: () =>
		set((state) => ({ commentsOpen: !state.commentsOpen })),
	setCommandOpen: (value) => set({ commandOpen: value }),
	toggleCommandOpen: () =>
		set((state) => ({ commandOpen: !state.commandOpen })),
	setIsAnimated: (value) => set({ isAnimated: value }),
	setIsClickAnimating: (value) => set({ isClickAnimating: value }),
	setAnimateClick: () => {
		set({ isClickAnimating: true })
		setTimeout(() => {
			set({ isClickAnimating: false })
		}, 80)
	},

	// Search
	searchQuery: "",
	setSearchQuery: (query) => set({ searchQuery: query }),

	// Comments
	isCommentMode: false,
	commentInput: null,
	selectedComment: null,
	setIsCommentMode: (value) => set({ isCommentMode: value }),
	setCommentInput: (input) => set({ commentInput: input }),
	setSelectedComment: (comment) => set({ selectedComment: comment }),

	// Navigation
	navigation: { currentView: null, breadcrumb: [], viewStack: [] },
	setNavigation: (nav) => set({ navigation: nav }),
}))
